import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-ki-laeuft',
  imports: [TranslatePipe],
  templateUrl: './ki-laeuft.component.html',
  styleUrl: './ki-laeuft.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiLaeuftComponent {
  readonly aktion = input.required<string>();
}
